import { FC, PropsWithChildren, useEffect, useMemo, useRef } from 'react';
import { MsalProvider } from '@azure/msal-react';
import { useNavigate } from 'react-router-dom';

import { getLandingPagePath } from '@/lib/storage';
import { getInstance, getNavigationClient, initializeMsal } from './instance';

export const CustomMsalProvider: FC<PropsWithChildren> = ({ children }) => {
  const navigate = useNavigate();
  const landingPageHandled = useRef(false);

  // set React Router navigation function
  useEffect(() => {
    const navigationClient = getNavigationClient();
    navigationClient.setNavigate(navigate);
    return () => {
      navigationClient.setNavigate(undefined);
    };
  }, [navigate]);

  // the redirect bridge returns to the page the login started on; from the home page, continue to the saved landing page.
  // navigate changes with every route and initializeMsal keeps its result for the page load, so this must only run once
  useEffect(() => {
    if (landingPageHandled.current) {
      return;
    }
    landingPageHandled.current = true;

    initializeMsal()
      .then((result) => {
        const landingPagePath = getLandingPagePath();
        if (result && landingPagePath && window.location.pathname === '/') {
          navigate(landingPagePath, { replace: true });
        }
      })
      .catch(console.error);
  }, [navigate]);

  const msalInstance = useMemo(() => getInstance(), []);

  return <MsalProvider instance={msalInstance}>{children}</MsalProvider>;
};
